var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    stroke: "#545454",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.666 13.667H2.999c-.366 0-.68-.13-.941-.392a1.284 1.284 0 0 1-.392-.942V9.667c.367 0 .68-.13.942-.392.26-.261.391-.575.391-.942 0-.366-.13-.68-.391-.941A1.284 1.284 0 0 0 1.666 7V4.333c0-.366.13-.68.392-.941.26-.261.575-.392.941-.392h10.667c.367 0 .68.13.942.392.26.26.391.575.391.941V7c-.366 0-.68.13-.941.392a1.284 1.284 0 0 0-.392.941c0 .367.13.68.392.942.26.261.575.392.941.392v2.666c0 .367-.13.68-.391.942a1.284 1.284 0 0 1-.942.392zm0-1.334v-1.7a2.733 2.733 0 0 1-.975-.975 2.564 2.564 0 0 1-.358-1.325c0-.477.12-.92.358-1.325.239-.405.564-.73.975-.975v-1.7H2.999v1.7c.411.245.736.57.975.975.24.406.359.848.359 1.325 0 .478-.12.92-.359 1.325-.239.406-.564.73-.975.975v1.7h10.667z",
    fill: "#545454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.583 9.084v1a.5.5 0 0 1-.5.5h-3.5a.5.5 0 0 1-.5-.5v-1m1-1.25 1.25 1.25m0 0 1.25-1.25m-1.25 1.25v-3",
    stroke: "{stroke}",
    strokeWidth: 0.887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateVoucher);
export default __webpack_public_path__ + "static/media/generateVoucher.7830cd4401cdeb575f6f0a0e0bbb0afb.svg";
export { ForwardRef as ReactComponent };